import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestFilterPipe } from './test-filter.pipe';
import { TimeFilterPipe } from './time-filter.pipe';
import { NumfilerPipe } from './numfiler.pipe';
import { N2brPipe } from './n2br.pipe';
import { HttpUrlPipe } from './http-url.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TestFilterPipe, TimeFilterPipe, NumfilerPipe, N2brPipe, HttpUrlPipe],
  exports: [TestFilterPipe, TimeFilterPipe, N2brPipe, HttpUrlPipe]
})
export class PipeModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/pipe/pipe.module.ts